import { START_WORKOUT_PATH } from '../../constants'
import { getObjectUtil } from 'packages/src'

const hasStartedStartWorkoutSelect = (state) => !!getObjectUtil(
  state,
  START_WORKOUT_PATH.HAS_STARTED
)

export default hasStartedStartWorkoutSelect
